import React from 'react';
import { Core, Form } from 'connex-cds';
import styled from 'styled-components';
import { useGetTicketSignature } from '../../useTicketSignature';

const Image = styled.img`
  height: 65px;
  max-width: 220px;
  -webkit-filter: var(--signature-image-invert);
  filter: var(--signature-image-invert);
`;

export const DamageWaiverSignatureImage = () => {
  const { values } = Form.useFormContext();

  const signatureUrl = React.useMemo(
    () => values?.damageWaiverSignature?.image,
    [values?.damageWaiverSignature?.image]
  );
  const { image, isLoading } = useGetTicketSignature({ signatureUrl });

  if (!image) {
    return null;
  }

  return (
    <Core.Spinner spin={isLoading}>
      <Image src={image} />
    </Core.Spinner>
  );
};
